import { Bell } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { NotificationPanel } from './notification-panel';
import { useNotifications } from '@/hooks/use-notifications';

export function NotificationBell() {
  const state = useNotifications();
  const unreadCount = state.notifications.filter((n) => !n.isRead).length;

  return (
    <TooltipProvider delayDuration={300}>
      <Popover>
        <Tooltip>
          <TooltipTrigger asChild>
            <PopoverTrigger asChild>
              <Button variant="ghost" size="icon" className="relative size-8">
                <Bell className="size-4" />
                {unreadCount > 0 && (
                  <span className="absolute -top-0.5 -right-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-primary px-1 text-[10px] font-bold text-primary-foreground animate-bounce-once">
                    {unreadCount > 99 ? '99+' : unreadCount}
                  </span>
                )}
              </Button>
            </PopoverTrigger>
          </TooltipTrigger>
          <TooltipContent side="bottom" sideOffset={8}>
            <p>
              {unreadCount > 0
                ? `${unreadCount} unread notification${unreadCount > 1 ? 's' : ''}`
                : 'No new notifications'}
            </p>
          </TooltipContent>
        </Tooltip>
        <PopoverContent
          className="p-0 w-[400px] max-w-[calc(100vw-2rem)] flex flex-col max-h-[calc(100svh-4rem)]"
          align="end"
          sideOffset={8}
        >
          <NotificationPanel
            notifications={state.notifications}
            unreadCount={unreadCount}
            loading={state.loading}
            onMarkAsRead={state.markAsRead}
            onMarkAllAsRead={state.markAllAsRead}
          />
        </PopoverContent>
      </Popover>
    </TooltipProvider>
  );
}
